<template>
  <div class="safe-report body">
    <el-container>
      <!-- <ExpenseAside /> -->
      <el-main>
        <el-row type="flex" justify="center" :gutter="10">
          <el-col :xl="16" :lg="16" :md="6" :sm="12">
            <div class="bg-White mt-2">
              <div class="block p-3">
                <!-- <span class="demonstration">Default</span> -->
                <el-date-picker
                  style="width: 100%"
                  @change="getSafeReport"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="الي"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="بداية الفترة"
                  end-placeholder="نهاية الفترة"
                  class="display-mobile-none"
                >
                </el-date-picker>
                <el-date-picker
                  type="date"
                  class="filter-mobile"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  @change="getSafeReport"
                  v-model="startDate"
                  placeholder="بداية الفترة"
                />
                <el-date-picker
                  type="date"
                  class="filter-mobile"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  @change="getSafeReport"
                  v-model="endDate"
                  placeholder="نهاية الفترة"
                />
              </div>
            </div>
          </el-col>
          <el-col class="mt-2" :xl="2" :lg="2" :md="6" :sm="12">
            <el-button
              class="mt-2"
              type="success"
              title="طباعه"
              icon="el-icon-printer"
              @click="sendToPrintAll(tableData)"
            ></el-button>
          </el-col>
        </el-row>
        <el-table
          class="mt-2 table-mobile"
          style="width: 80%; margin-right: 10%"
          align="center"
          v-if="tableData.length > 0"
          :data="tableData"
          border
        >
          <el-table-column
            label="#"
            type="index"
            width="50"
            class-name="display-mobile-none"
          />
          <el-table-column
            width="300"
            label="المصروف"
            prop="category.description"
          >
            <template slot-scope="scope">
              <span class="label"> {{ scope.$index + 1 }} # المصروف</span>
              <div>{{ scope.row.category.description }}</div>
            </template>
          </el-table-column>
          <el-table-column width="200" label="المبلغ" prop="cost">
            <template slot-scope="scope">
              <span class="label">المبلغ</span>
              <div>{{ scope.row.cost }}</div>
            </template>
          </el-table-column>

          <el-table-column label="تفاصيل">
            <template slot-scope="scope">
              <router-link
                title=" تفاصيل"
                class="btn btn-sm btn-success"
                :to="{
                  path: `/expenses/details?category=${
                    scope.row.category_id
                  }&start_date=${
                    dateRange ? dateRange[0] : startDate
                  }&end_date=${dateRange ? dateRange[1] : endDate}`,
                }"
              >
                <i class="fa fa-eye ml-1"></i>
                عرض التفاصيل
              </router-link>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import ExpenseAside from "@/components/ExpenseAside.vue";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";

export default {
  name: "CustomerReport",
  // components: { ExpenseAside },
  data() {
    return {
      false: false,
      true: true,
      dateRange: null,
      totalExpenses: 0,
      tableData: [],
      startDate: "",
      endDate: "",
    };
  },
  methods: {
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    getSafeReport() {
      if (this.dateRange != null || this.startDate || this.endDate) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        let url = `categories-expenses`;
        if (this.dateRange != null) {
          url += `/${this.dateRange[0]}`;
          url += `/${this.dateRange[1]}`;
        }
        if (this.startDate) {
          url += `/${this.startDate}`;
        }
        if (this.endDate) {
          url += `/${this.endDate}`;
        }
        this.totalExpenses = 0;
        const vm = this;
        axiosApi
          .get(url)
          .then((response) => {
            this.tableData = response.data;

            this.tableData.map(function (value) {
              vm.totalExpenses += value["cost"];
            });
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    sendToPrintAll() {
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: tableData,
      //   type: "Expenses",
      //   dateRange: this.dateRange,
      //   title: "all",
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
  },
};
</script>
